// extracted by mini-css-extract-plugin
export default {"selectContent":"UserForm_selectContent__vLGSr","buttonContainer":"UserForm_buttonContainer__1pBJZ","label":"UserForm_label__NdFWz","selectBlock":"UserForm_selectBlock__yqQv-"};